export default "__VITE_ASSET__2TNZB0WE__"